import axios from 'axios';
import { rootWithLanguage } from '../utils/paths';
import Autocomplete from '../components/search/autocomplete';

class Error {
  constructor() {
    this.dom = {
      searchForm: document.getElementById('error-search-form'),
      searchFormInput: document.getElementById('error-search-form-input'),
    };

    this.data = {
      // https://www.fusejs.io/api/options.html#options
      fuseOptions: {
        isCaseSensitive: false,
        shouldSort: true,
        minMatchCharLength: 3,
        threshold: 0.3,
        includeMatches: true,
        keys: ['name', 'keywords'],
      },
      autocompleteOptions: {
        maxResults: 5,
        itemHeading: 'category',
        itemName: 'name',
        itemUrl: 'url',
      },
      questionsApiUrl: `${rootWithLanguage}suggestions`,
    };

    this.autocomplete = null;

    this.mount();
  }

  async mount() {
    if (this.dom.searchForm) {
      try {
        // fetch data
        const response = await axios.get(this.data.questionsApiUrl);
        // initialize autocomplete
        this.autocomplete = new Autocomplete({
          autocompleteContainer: this.dom.searchForm,
          data: response.data ?? [],
          autocompleteOptions: this.data.autocompleteOptions,
          fuseOptions: this.data.fuseOptions,
        });
        this.dom.searchFormInput.focus();
      } catch (error) {
        throw Error(error);
      }
    }
  }
}

if (document.getElementById('page-error')) {
  // eslint-disable-next-line no-new
  new Error();
}
